export default "__VITE_ASSET__DjDwLsYJ__"